import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { BookCanvas } from './GoldScene';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

export default function AuthorSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      const t = { trigger: ref.current, start: 'top 55%' };
      gsap.fromTo('.auth-book', { opacity: 0, scale: 0.92 }, { opacity: 1, scale: 1, duration: 1.1, ease: 'power3.out', scrollTrigger: t });
      gsap.fromTo('.auth-text', { opacity: 0, x: 50 }, { opacity: 1, x: 0, duration: 1, ease: 'power4.out', scrollTrigger: t });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec auth" ref={ref}>
      <svg className="auth-arcs" viewBox="0 0 1200 800" preserveAspectRatio="none">
        {[...Array(6)].map((_, i) => (
          <ellipse key={i} cx="0" cy="400" rx={160 + i * 120} ry={100 + i * 65}
            fill="none" stroke="rgba(201,168,76,0.04)" strokeWidth="1" strokeDasharray="5 9" />
        ))}
      </svg>
      <div className="auth-grid">
        <div className="auth-book">
          <BookCanvas />
        </div>
        <div className="auth-text">
          <span className="pill">MENGENALI PENULIS</span>
          <h2>Adam<br/>Danish</h2>
          <p className="auth-role">Professional Gold Trader &amp; Educator</p>
          <p className="auth-quote">
            "Dulu aku cuma budak yang percaya satu benda — gold tak pernah tipu orang yang sabar.
            Aku jatuh. Aku loss. Tapi aku tak berhenti. Aku swing gold sampai 1 juta USD bukan
            sebab nasib, tapi sebab aku belajar macam mana nak jadi trader yang tenang."
          </p>
          <p className="auth-note">Semua cara aku, dari entry sampai mindset, aku letak dalam buku TLP. Ini bukan buku motivasi. Ini bukti.</p>
          <div className="auth-stats">
            <div className="a-stat"><span className="a-val">$1M+</span><span className="a-label">PORTFOLIO</span></div>
            <div className="a-stat"><span className="a-val">500+</span><span className="a-label">PEMBACA</span></div>
            <div className="a-stat"><span className="a-val">100%</span><span className="a-label">MONEY-BACK</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
